class CartNotificationClone extends HTMLElement {
  constructor() {
    super();

    this.freeDeliveryCustomEl = document.querySelector("free-delivery");
    this.closeBtn = document.querySelector(
      ".cart-notification-clone-close-btn",
    );
    this.notificationCustomEl = document.querySelector("cart-notification");
    this.notificationClone = document.getElementById("cart-notification-clone");
    this.notificationCloneWrapper = document.getElementById(
      "cart-notification-clone-wrapper",
    );
    this.notificationCloneProductList = document.getElementById(
      "cart-notification-clone-product-list",
    );
    this.notificationCloneSubtotal = document.getElementById(
      "cart-notification-clone-price-subtotal",
    );
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (this.notificationCloneWrapper) {
      this.notificationCloneWrapper.addEventListener("click", (e) => {
        this.handleBodyClick(e);
      });
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", () => {
        this.hideClone();
      });
    }

    if (this.notificationClone) {
      this.notificationClone.addEventListener("click", (e) => {
        if (e.target.classList.contains("cart-notification-clone-minus-btn")) {
          const quantityInput = e.target.parentElement.querySelector("input");
          e.target.parentElement.setAttribute("inactive", "");

          if (+quantityInput.value < 2) {
            this.sendUpdateRequest(
              quantityInput,
              0,
              +quantityInput.getAttribute("data-line-index"),
              "minus",
            );
            return;
          }

          this.sendUpdateRequest(
            quantityInput,
            +quantityInput.value - 1,
            +quantityInput.getAttribute("data-line-index"),
            "minus",
          );
        }

        if (e.target.classList.contains("cart-notification-clone-plus-btn")) {
          const quantityInput = e.target.parentElement.querySelector("input");
          e.target.parentElement.setAttribute("inactive", "");

          this.sendUpdateRequest(
            quantityInput,
            +quantityInput.value + 1,
            +quantityInput.getAttribute("data-line-index"),
            "plus",
          );
        }
      });
    }
  }

  sendUpdateRequest(quantityInput, newQuantity, lineIndex = 0, action) {
    const updateConfig = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: newQuantity, line: lineIndex }),
    };

    fetch(`${routes.cart_change_url}`, updateConfig)
      .then(() => {
        if (newQuantity === 0) {
          this.removeProductElement(quantityInput, lineIndex);
        }

        this.updateQuantity(quantityInput, action);
        this.updateProductDetails(quantityInput);
        this.updateSubtotal();

        if (this.freeDeliveryCustomEl && this.notificationCloneSubtotal) {
          this.freeDeliveryCustomEl.checkDelivery(
            +this.notificationCloneSubtotal.getAttribute("data-subtotal"),
          );
        }

        if (this.notificationCustomEl) {
          this.notificationCustomEl.fetchCartContents();
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        quantityInput.parentElement.removeAttribute("inactive");
        this.addQuantityInputEvents();
      });
  }

  checkCartContents() {
    const cartItems = this.notificationCloneProductList.querySelectorAll(
      ".cart-notification-product--clone",
    );

    if (cartItems.length < 1) {
      this.notificationCloneProductList.innerHTML = `
        <span>${this.notificationCloneProductList.getAttribute(
          "data-cart-empty",
        )}</span>
      `;
    }
  }

  removeProductElement(quantityInput, lineIndex) {
    quantityInput.closest(".cart-notification-product--clone").remove();

    this.querySelectorAll(".cart-notification-clone-quantity").forEach(
      (quantity) => {
        const quantityIndex = +quantity.getAttribute("data-line-index");

        if (quantityIndex > lineIndex) {
          quantity.setAttribute("data-line-index", quantityIndex - 1);
        }
      },
    );

    this.checkCartContents();
  }

  updateProductDetails(quantityInput) {
    const priceTags = quantityInput
      .closest("quantity-input")
      .parentElement.querySelectorAll(
        ".cart-notification-product__details-price--clone",
      );

    priceTags.forEach((tag) => {
      const tagMoneyEl = tag.querySelector(".money");
      const previousTotal = tag.getAttribute("data-product-price-total");
      const newTotal = (
        quantityInput.value * +tag.getAttribute("data-product-price")
      ).toFixed(2);

      tag.setAttribute("data-product-price-total", newTotal);

      if (tagMoneyEl) {
        tagMoneyEl.textContent = tagMoneyEl.textContent.replace(
          previousTotal,
          newTotal,
        );
      }
    });
  }

  updateSubtotal() {
    const subTotal = [
      ...this.querySelectorAll(".cart-notification-product__details-new-price"),
    ]
      .reduce(
        (acc, productPrice) =>
          Number(productPrice.getAttribute("data-product-price-total")) + acc,
        0,
      )
      .toFixed(2);

    const previousTotal =
      this.notificationCloneSubtotal.getAttribute("data-subtotal");

    this.notificationCloneSubtotal.textContent =
      this.notificationCloneSubtotal.textContent.replace(previousTotal, subTotal);

    this.notificationCloneSubtotal.setAttribute("data-subtotal", subTotal);
  }

  updateQuantity(quantityInput, action) {
    if (action === "plus") {
      quantityInput.value = +quantityInput.value + 1;
    }

    if (action === "minus") {
      quantityInput.value = +quantityInput.value - 1;
    }

    quantityInput.setAttribute("value", quantityInput.value);

    this.showCartRecommendations();
  }

  addQuantityInputEvents() {
    this.notificationCloneQuantities = document.querySelectorAll(
      ".cart-notification-clone-quantity",
    );

    this.notificationCloneQuantities.forEach((input) => {
      input.addEventListener("keyup", (e) => {
        const quantityInput = e.target;

        setTimeout(() => {
          quantityInput.parentElement.setAttribute("inactive", "");

          if (+quantityInput.value > 0) {
            this.sendUpdateRequest(
              quantityInput,
              +quantityInput.value,
              +quantityInput.getAttribute("data-line-index"),
            );
          } else {
            this.sendUpdateRequest(
              quantityInput,
              0,
              +quantityInput.getAttribute("data-line-index"),
              "minus",
            );
          }
        }, 1000);
      });
    });
  }

  showClone() {
    const quickAddModal = document.querySelector(
      ".pdp__quickAds-modal-container",
    );

    if (quickAddModal) {
      quickAddModal.classList.remove("open");
    }

    this.notificationCloneWrapper.classList.add("active");

    if (this.freeDeliveryCustomEl && this.notificationCloneSubtotal) {
      this.freeDeliveryCustomEl.checkDelivery(
        +this.notificationCloneSubtotal.getAttribute("data-subtotal"),
      );
    }

    this.addQuantityInputEvents();
    this.showCartRecommendations();
  }

  hideClone() {
    this.notificationCloneWrapper.classList.remove("active");
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (
      target !== this.notificationClone &&
      !target.closest("#cart-notification-clone")
    ) {
      this.hideClone();
    }
  }

  async showCartRecommendations() {
    const cartRecommendationsContainer = this.querySelector(
      "#cart-recommendations",
    );
    const cartRecommendationsTitle = this.querySelector(
      "#sidecart-products-recommends",
    );

    if (!window.ecs || typeof window.ecs.getCartRecommendations !== "function") {
      cartRecommendationsTitle?.classList.add("hidden");
      return;
    }

    const response = await window.ecs.getCartRecommendations();
    const products = response?.recommendations;

    if (!products || products.length < 1 || !cartRecommendationsContainer) {
      const existingSection = this.querySelector(".auc-Recommend");

      if (existingSection) {
        existingSection.style.display = "none";
      }

      cartRecommendationsTitle?.classList.add("hidden");

      return;
    }

    cartRecommendationsTitle?.classList.remove("hidden");

    cartRecommendationsContainer.innerHTML = `
      <section class="auc-Recommend">
        <div class="auc-Recommend-container">
          <ol class="auc-Recommend-list"></ol>
        </div>
      </section>
    `;

    const listContainer = cartRecommendationsContainer.querySelector(
      ".auc-Recommend-list",
    );

    products.forEach((product) => {
      const productUrl = `${window.Shopify?.routes?.root || "/"}products/${
        product.handle
      }`;

      const currencySymbol = "£";
      const li = document.createElement("li");

      li.className = "auc-Recommend-item";
      li.innerHTML = `
        <a class="card-product card-carousel-js swiper-slide frequent-product-card" href="${productUrl}" data-type="trending">
          <img 
            class="trending-product-img card-product__image" 
            src="${product.image}" 
            alt="${product.title}" 
            style="width: 100px;"
          />
          <div class="frequent-product-details">
            <h4 class="frequent-product-name card-product__heading">${product.title}</h4>
            <span class="card-product__price frequent-product-price">${currencySymbol}${product.price}</span>
          </div>
        </a>
      `;

      listContainer.appendChild(li);
    });
  }
}

customElements.define("cart-notification-clone", CartNotificationClone);